<div class="file-management-container">

  <div class="page-heading">

    <div class="heading-actions">


      @if (isInternal && canEdit(selectedModule)) {
        <button class="action-btn primary" (click)="openCreateFolder()"
          [title]="'fileManagement.newFolder' | translate">
          <i class="bi bi-folder-plus" style="color: white;"></i>
        </button>
        <button class="action-btn primary" (click)="openUploadFile()"
          [title]="'fileManagement.uploadFile' | translate">
          <i class="bi bi-upload" style="color: white;"></i>
        </button>
      }
    </div>
  </div>

  <section class="portal-services">
    <h3 class="section-title">{{ 'fileManagement.portalServices' | translate }}</h3>
    <div class="service-cards">
      @for (folder of rootFolders; track trackByFolderId($index, folder)) {
        <button
          class="service-card"
          [class.active]="activeRootFolderId === folder.id"
          (click)="navigateToFolder(folder.id)">
          <span class="service-icon">
            <img [src]="activeRootFolderId === folder.id ? 'assets/icons/files-management/selected-folder.svg' : 'assets/icons/files-management/folder.svg'"
              alt="folder" />
            </span>
            <span class="service-name">{{ getFolderName(folder) }}</span>
          </button>
        }

        @if (isInternal) {
          <button class="add-service-card" (click)="openCreateFolder(true)">
            <i class="bi bi-plus-lg"></i>
          </button>
        }
      </div>
    </section>

    <section class="documents-section">
      <div class="section-header">
        <h3 class="sub-title">{{ 'fileManagement.libraryDocuments' | translate }}</h3>
        <div class="section-actions">
          <div class="view-toggle">
            <button class="view-icon-btn" [class.active]="viewMode === 'grid'" (click)="viewMode='grid'"
              [title]="'fileManagement.gridView' | translate">
              <img class="grid-icon" src="assets/icons/files-management/grid.svg" alt="grid" width="20" height="20" />
            </button>
            <button class="view-icon-btn" [class.active]="viewMode === 'list'" (click)="viewMode='list'"
              [title]="'fileManagement.listView' | translate">
              <img src="assets/icons/files-management/list.svg" alt="list" width="20" height="20" />
            </button>
          </div>
        </div>
      </div>

      <div class="explorer-content" [ngClass]="viewMode">
        @if (getCurrentFolders().length === 0 && getCurrentFiles().length === 0) {
          <div class="empty-state">
            <div class="empty-state-content">
              <i class="bi bi-folder-x empty-icon"></i>
              <p>{{ 'fileManagement.emptyFolder' | translate }}</p>
            </div>
          </div>
        }

        @for (folder of getCurrentFolders(); track trackByFolderId($index, folder)) {
          <div
            class="item folder-item card-tile" (dblclick)="navigateToFolder(folder.id)" (click)="handleFolderClick($event, folder.id)">
            <div class="item-icon">
              <img [src]="getFolderTileIcon(folder.id)" alt="folder"/>
            </div>
            <div [ngClass]="currentLanguage === 'ar' ? 'item-info-rtl' : 'item-info'">
              <div class="item-name">{{ getFolderName(folder) }}</div>
              <button type="button" class="info-icon-btn" [attr.data-tooltip]="getFolderDescription(folder)" [attr.aria-label]="getFolderDescription(folder)" (click)="$event.stopPropagation()">
                <i class="bi bi-info-circle"></i>
              </button>
            </div>
            @if (isInternal) {
              <div class="item-actions top-0 end-0 m-1"
                [ngClass]="viewMode=='grid' ? 'position-absolute' : ''">
                <div class="dropdown">
                  <button #folderMenuInfo class="btn btn-sm btn-light" style="background: transparent;padding:0;"
                    type="button" (click)="toggleFolderMenu(folder.id, $event)">
                    <i class="bi bi-three-dots-vertical"></i>
                  </button>
                  <ul class="dropdown-menu"
                    [ngStyle]="currentLanguage==='ar' && viewMode==='list'? {'transform': 'translate(110px, -22px)'} : {}"
                    [class.show]="openMenuFolderId === folder.id" style="min-width: 100px;">
                    <li><button class="dropdown-item" (click)="openEditFolder(folder); closeFolderMenu()">✎
                    {{ 'common.edit' | translate }}</button></li>
                    <li><button class="dropdown-item" (click)="deleteFolder(folder.id); closeFolderMenu()">🗑
                    {{ 'common.delete' | translate }}</button></li>
                  </ul>
                </div>
              </div>
            }
          </div>
        }

        @for (file of getCurrentFiles(); track trackByFileId($index, file)) {
          <div class="item file-item card-tile"
            (click)="openFile(file)" style="cursor: pointer;">
            <div class="item-icon file-icon">
              <img [src]="getFileAsset(file)" [alt]="file.type"/>
            </div>
            <div [ngClass]="currentLanguage === 'ar' ? 'item-info-rtl' : 'item-info'">
              <div class="item-name">{{ getFileTitle(file) }}</div>
              <button type="button" class="info-icon-btn"  [attr.data-tooltip]="getFileDescription(file)" [attr.aria-label]="getFileDescription(file)" (click)="$event.stopPropagation()">
                <i class="bi bi-info-circle"></i>
              </button>
              <div class="item-meta">{{ file.type }} • {{ file.size }}</div>
            </div>
            @if (isInternal) {
              <div class="item-actions top-0 end-0 m-1"
                [ngClass]="viewMode=='grid' ? 'position-absolute' : ''" (click)="$event.stopPropagation()">
                <div class="dropdown">
                  <button #fileMenuInfo class="btn btn-sm btn-light" style="background: transparent;padding:0;"
                    type="button" (click)="toggleFileMenu(file.id,$event)">
                    <i class="bi bi-three-dots-vertical"></i>
                  </button>
                  <ul class="dropdown-menu"
                    [ngStyle]="currentLanguage==='ar' && viewMode==='list'? {'transform': 'translate(110px, -22px)'} : {}"
                    [class.show]="openMenuFileId === file.id" style="min-width: 100px;">
                    <li><button class="dropdown-item" (click)="editFile(file); closeFileMenu()">✎
                    {{ 'common.edit' | translate }}</button></li>
                    <li><button class="dropdown-item" (click)="deleteFile(file.id); closeFileMenu()">🗑
                    {{ 'common.delete' | translate }}</button></li>
                  </ul>
                </div>
              </div>
            }
          </div>
        }
      </div>
      <!-- <div class="pagination-container" *ngIf="getTotalPages() > 1"> -->

      <div class="pagination-container" >
        <div class="pagination-info">
          <span>{{ 'fileManagement.paginationInfo' | translate:{ total: getTotalItems(), current: currentPage, totalPages: getTotalPages() } }}</span>
        </div>

        <div class="pagination-controls">
          <button class="pagination-btn" (click)="prevPage()" [disabled]="currentPage === 1"
            title="{{ 'fileManagement.previousPage' | translate }}">
            <i [ngClass]="currentLanguage === 'ar' ? 'bi bi-chevron-right' : 'bi bi-chevron-left'"></i>
          </button>

          @for (page of getPageNumbers(); track trackByPageNumber($index, page)) {
            <button class="pagination-btn page-number"
              [class.active]="page === currentPage" (click)="goToPage(page)">
              {{ page }}
            </button>
          }

          <button class="pagination-btn" (click)="nextPage()" [disabled]="currentPage === getTotalPages()"
            title="{{ 'fileManagement.nextPage' | translate }}">
            <i [ngClass]="currentLanguage === 'ar' ? 'bi bi-chevron-left' : 'bi bi-chevron-right'"></i>
          </button>
        </div>
      </div>

    </section>

    <!-- Modal: Create Folder -->
    @if (isInternal && showCreateFolder) {
      <div class="custom-modal-overlay" (click)="showCreateFolder=false">
        <div class="custom-modal" (click)="$event.stopPropagation()">
          <div class="modal-header">
            <h3>{{ (editingFolderId ? 'fileManagement.editFolderTitle' : 'fileManagement.createFolderTitle') |
            translate }}</h3>
            <button class="modal-close" (click)="showCreateFolder=false">×</button>
          </div>
          <form class="modal-form" (ngSubmit)="createFolder()">
            <div class="form-row">
              <div class="form-group">
                <label>{{ 'fileManagement.folderNameEn' | translate }} <span class="required">*</span></label>
                <input type="text" [(ngModel)]="folderForm.nameEn" name="nameEn" required />
              </div>
              <div class="form-group">
                <label>{{ 'fileManagement.folderNameAr' | translate }}</label>
                <input type="text" [(ngModel)]="folderForm.nameAr" name="nameAr" dir="rtl" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group">
                <label>{{ 'fileManagement.folderDescEn' | translate }}</label>
                <textarea [(ngModel)]="folderForm.descriptionEn" name="descEn" rows="3"></textarea>
              </div>
              <div class="form-group">
                <label>{{ 'fileManagement.folderDescAr' | translate }}</label>
                <textarea [(ngModel)]="folderForm.descriptionAr" name="descAr" rows="3" dir="rtl"></textarea>
              </div>
            </div>
            <div class="modal-actions">
              <button type="button" class="btn secondary" (click)="showCreateFolder=false">{{ 'common.cancel' |
              translate }}</button>
              <button type="submit" class="btn primary">
                {{ (editingFolderId ? 'fileManagement.updateFolder' : 'fileManagement.createFolderTitle') |
                translate }}
              </button>
            </div>
          </form>
        </div>
      </div>
    }

    <!-- Modal: Upload File with Multi-Step Form -->
    @if (isInternal && showUploadFile) {
      <div class="custom-modal-overlay" (click)="showUploadFile=false;editingFileId=null;">
        <div class="custom-modal large" (click)="$event.stopPropagation()">
          <div class="modal-header">
            <h3>{{ (editingFileId ? 'fileManagement.editFileTitle' : 'fileManagement.uploadFileTitle') | translate
            }}</h3>
            <button class="modal-close" (click)="showUploadFile=false;editingFileId=null;">×</button>
          </div>
          <!-- Stepper Tabs -->
          <div class="stepper-tabs">
            <div class="stepper-tab" [class.active]="uploadStep === 1" [class.completed]="uploadStep > 1"
              (click)="uploadStep = 1" role="button" tabindex="0">
              <div class="stepper-step">
                <span class="step-number">1</span>
                <span class="step-label">{{ 'fileManagement.step1' | translate }}</span>
              </div>
            </div>
            <div class="stepper-tab" [class.active]="uploadStep === 2" [class.completed]="uploadStep > 2"
              (click)="uploadStep = uploadStep > 1  ? 2 :  (!!editingFileId ? 2 : 1)" role="button" tabindex="0">
              <div class="stepper-step">
                <span class="step-number">2</span>
                <span class="step-label">{{ 'fileManagement.step2' | translate }}</span>
              </div>
            </div>
          </div>
          <!-- Step 1: File Information -->
          @if (uploadStep === 1) {
            <div class="modal-form">
              <form (ngSubmit)="goToNextStep()">
                <div class="form-row">
                  <div class="form-group">
                    <label>{{ 'fileManagement.fileNameEn' | translate }} <span class="required">*</span></label>
                    <input type="text" [(ngModel)]="fileForm.titleEn" name="titleEn" required />
                  </div>
                  <div class="form-group">
                    <label>{{ 'fileManagement.fileNameAr' | translate }} <span class="required">*</span></label>
                    <input type="text" [(ngModel)]="fileForm.titleAr" name="titleAr" required dir="rtl" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group">
                    <label>{{ 'fileManagement.fileDescEn' | translate }}</label>
                    <textarea [(ngModel)]="fileForm.descriptionEn" name="descEn" rows="3"></textarea>
                  </div>
                  <div class="form-group">
                    <label>{{ 'fileManagement.fileDescAr' | translate }}</label>
                    <textarea [(ngModel)]="fileForm.descriptionAr" name="descAr" rows="3" dir="rtl"></textarea>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group">
                    <label>{{ 'common.name' | translate }} <span class="required">*</span></label>
                    <select [(ngModel)]="fileForm.documentType" name="docType" required>
                      <option value="">{{ 'common.noData' | translate }}</option>
                      <option value="SOP">SOP</option>
                      <option value="Form">Form</option>
                      <option value="Program">Program</option>
                      <option value="Policy">Policy</option>
                      <option value="Manual">Manual</option>
                      <option value="Report">Report</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>{{ 'common.name' | translate }} <span class="required">*</span></label>
                    <select [(ngModel)]="fileForm.language" name="language" required>
                      <option value="">{{ 'common.noData' | translate }}</option>
                      <option value="EN">English</option>
                      <option value="AR">Arabic</option>
                    </select>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group">
                    <label>{{ 'common.name' | translate }} <span class="required">*</span></label>
                    <input type="date" [(ngModel)]="fileForm.uploadDate" name="uploadDate" required />
                  </div>
                  <div class="form-group">
                    <label>{{ 'fileManagement.selectFile' | translate }} <span class="required">*</span></label>
                    <input type="file" (change)="onFileSelected($event)" required />
                  </div>
                </div>
                <div class="modal-actions">
                  <button type="button" class="btn secondary" (click)="showUploadFile=false;editingFileId=null;">
                    {{ 'common.cancel' | translate }}
                  </button>
                  <button type="submit" class="btn primary">
                    {{ 'common.next' | translate }}
                    <i
                    [ngClass]="currentLanguage === 'ar' ? 'bi bi-chevron-left ms-1' : 'bi bi-chevron-right ms-1'"></i>
                  </button>
                </div>
              </form>
            </div>
          }
          <!-- Step 2: Permissions -->
          @if (uploadStep === 2) {
            <div class="modal-form">
              <app-permissions-tab
                #permissionsTab
                [fileId]="editingFileId">
              </app-permissions-tab>
              <div class="modal-actions">
                <button type="button" class="btn secondary" (click)="goToPreviousStep()">
                  <i [ngClass]="currentLanguage === 'ar' ? 'bi bi-chevron-right me-1' : 'bi bi-chevron-left me-1'"></i> {{ 'common.previous' | translate }}
                </button>
                <button type="button" class="btn secondary" (click)="showUploadFile=false">
                  {{ 'common.cancel' | translate }}
                </button>
                <button type="button" class="btn primary" (click)="uploadFile()">
                  <i class="bi bi-check-lg me-1"></i> {{ 'common.save' | translate }} {{ 'common.all' | translate }}
                </button>
              </div>
            </div>
          }
        </div>
      </div>
    }


  </div>